import { Link } from "react-router-dom";
import logo from "./assest/logo.jpg";
const Nav = () => {
  return (
    <nav className="w-full z-10 bg-white ">
      <input type="checkbox" id="check" hidden />
      <label
        htmlFor="check"
        className="float-right text-black leading-[80px] text-3xl mr-10 lg:hidden"
      >
        <i className="fas fa-bars"></i>
      </label>
      
      <div className="h-14 md:h-20 flex">
        <img src={logo} alt="logo" />
      </div>

      <ul className="float-right mr-10 lg:flex leading-[70px] space-x-4 text-black uppercase rounded fixed lg:relative h-[100vh] lg:h-0 w-[100%] lg:w-fit top-15 lg:top-0 left-[-100%] lg:left-0 transition-all duration-300 lg:transition-none text-center bg-white z-10">
        <li>
          <Link to="/">Home</Link>
        </li>

        <li>
          <Link to="/product">Products</Link>
        </li>
        <li>
          <Link to="/about">About Us</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
